import { Injectable } from '@angular/core';

import { ContractInterface } from '../data';
import { MemoryCacheRepository } from './memory-cache.repository';

@Injectable()
export class ContractCacheRepository extends MemoryCacheRepository<ContractInterface> {}
